module.exports = __webpack_public_path__ + "img/zidong.15aa4cd0.png";